import { render, staticRenderFns } from "./IconPackage.vue?vue&type=template&id=ec23d912"
import script from "./IconPackage.vue?vue&type=script&lang=js"
export * from "./IconPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports